'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ErrorBanner = require('../../../../../common/components/ErrorBanner.js');
var Box = require('../../../../../common/components/layout/Box/Box.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ClaimSummaryHeader = _ref => {
  let {
    submitClaimStatus,
    title,
    subtitle
  } = _ref;
  const {
    claimsSummarySubmitApiError
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, submitClaimStatus.error && !submitClaimStatus.loading && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      paddingBottom: '1rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, claimsSummarySubmitApiError)), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 1,
    style: {
      textAlign: 'center',
      marginBottom: '2rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, {
    as: "h1"
  }, title), subtitle && /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "p"
  }, subtitle)));
};
var ClaimSummaryHeader$1 = nthHookTranslations.withTranslationsProvider(ClaimSummaryHeader, {
  translationKeys: ['claimsSummarySubmitApiError']
});

exports["default"] = ClaimSummaryHeader$1;
